'use client';

import { useAppSelector } from '../store/hooks';
import { selectBranding, type BrandingState } from '../store/slices/brandingSlice';

/**
 * Returns the current branding values (company name, product name, assistant name, etc.)
 * resolved from `/api/config/get-main_config` at app startup. Falls back to hardcoded
 * Kobotto / Smart Matrix defaults before the fetch completes, so components can read
 * `productName` / `companyName` synchronously without worrying about loading states.
 */
export function useBranding(): BrandingState {
  return useAppSelector(selectBranding);
}
